"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.widgets.disabled': 'La funzione widget non è disponibile nel tuo piano attuale.',
};
